<template>
  <div class="reportList_wrapper">
    <div class="report_filter_wrapper">
      <div class="filter_area_left">
        <van-field
          v-model="dateStr"
          label="时间筛选"
          placeholder="开始日期至结束日期"
          readonly
          @click="calenderShow = true"
        />
        <van-field
          v-model="typeStr"
          label="类型筛选"
          readonly
          placeholder="请选择类型"
          @click="typeModalShow = true"
        />
      </div>
      <div class="filter_area_right">
        <van-button type="default" @click.stop="handleDealReset"
          >重置</van-button
        >
        <van-button type="info" @click.stop="handleDealSelect">查询</van-button>
      </div>
    </div>
    <div class="reportContent_wrapper" v-if="dataContent">
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="
          reportList.length > 10
            ? '没有更多了'
            : reportList.length === 0
            ? '暂无数据'
            : ''
        "
        :immediate-check="false"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        @load="onLoad"
      >
        <div
          :class="[
            'mainContent_wrapper',
            `mainContent_wrapper_${loading ? 1 : 0}`,
          ]"
        >
          <div
            class="singleList_wrapper"
            v-for="item in reportList"
            :key="item.id"
          >
            <div class="left_box">
              <div class="name_box">
                <span class="username">{{ item.reportMemberName }}</span>
              </div>
              <div
                class="image_box"
                v-if="item.imageUrl"
                @click="handleCheckImg(item.imageUrl)"
              >
                <!-- <img :src="item.imageUrl" alt="" /> -->
                <img v-lazy="item.imageUrl" alt="" />
              </div>
            </div>
            <div class="merchant_info_box">
              <span class="merchant_name">{{ item.merchantName }}</span>
              <div class="time_box">
                {{ transReportTime(item.reportTime) }}
              </div>
              <div class="desc_box">
                <span class="tit">上报类型：</span>
                <div class="type_tag_box">
                  <span
                    class="type_tag"
                    v-for="(type, index) in item.reportTypeNameList"
                    :key="index"
                    >{{ type }}</span
                  >
                </div>
              </div>
              <div class="desc_wrap">
                <span class="tit">补充说明：</span>
                <span class="desc">{{ item.description || '--' }}</span>
              </div>
            </div>
          </div>
        </div>
      </van-list>
      <!-- 日期modal -->
      <van-calendar
        :style="{'padding-bottom': '20px'}"
        type="range"
        color="#528AF0"
        :show-confirm="true"
        v-model="calenderShow"
        :min-date="minDate"
        :max-date="maxDate"
        :max-range="90"
        :allow-same-day="true"
        :safe-area-inset-bottom="true"
        :lazy-render="false"
        :default-date="defaultDate"
        @confirm="onConfirm"
      />
      <!-- 类型筛选modal -->
      <van-popup
        v-model="typeModalShow"
        position="bottom"
        closeable
        :style="{ width: '100%', height: '40%', 'padding-top': '50px' }"
      >
        <van-radio-group v-model="filterForm.reportType">
          <van-cell-group>
            <van-cell
              v-for="item in reportFilterList"
              clickable
              :key="item.type"
              :title="item.name"
              @click="filterForm.reportType = item.type"
            >
              <template #right-icon>
                <van-radio :name="item.type" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </van-popup>

      <!-- 图片预览 -->
      <van-image-preview
        v-model="imageShow"
        :images="images"
        :show-index="false"
        :closeable="true"
      />
    </div>
    <Loading v-else />
  </div>
</template>
<script>
import Network from "@/components/network";
import Loading from "@/components/loading";
import { reqReportPageList, reqReportType } from "@/apis/serviceApi.js";
import Vue from "vue";
import {
  Calendar,
  Popup,
  Cell,
  CellGroup,
  PullRefresh,
  Button,
  Field,
  ImagePreview,
  RadioGroup,
  Radio,
  Lazyload
} from "vant";
import { handleBuryPoint } from "@/utils/tool.js";
import dayjs from "dayjs";
Vue.use(Calendar)
  .use(Popup)
  .use(Cell)
  .use(CellGroup)
  .use(Radio)
  .use(RadioGroup)
  .use(PullRefresh)
  .use(Button)
  .use(Field)
  .use(ImagePreview)
  .use(Lazyload);
export default {
  components: {
    Network,
    Loading,
  },
  data() {
    return {
      dataContent: false,
      reportFilterList: [],
      reportList: [], // 上报线索列表
      filterForm: {
        reportTimeStart: null,
        reportTimeEnd: null,
        reportType: null, // 上报类型-单选
      },
      pageNum: 1,
      pageSize: 10,
      loading: false,
      finished: false,
      error: false,
      showEmptyData: false,
      calenderShow: false, // 是否展示日历
      typeModalShow: false, // 是否展示 上报类型弹窗
      minDate: null,
      maxDate: null,
      imageShow: false,
      images: [],
      defaultDate: null,
    };
  },
  computed: {
    typeStr() {
      const { reportType } = this.filterForm;
      const ans = this.reportFilterList
        .filter((item) => item.type === +reportType)
        .map((item) => item.name);
      return ans.length > 0 ? ans.join(",") : "";
    },
    dateStr() {
      const { reportTimeStart, reportTimeEnd } = this.filterForm;
      if (!reportTimeStart || !reportTimeEnd) {
        return "";
      }
      return `${dayjs(reportTimeStart).format("YYYY-MM-DD")} 至 ${dayjs(
        reportTimeEnd
      ).format("YYYY-MM-DD")}`;
    },
  },
  created() {
    handleBuryPoint("h5-sudaseeker_reportListPage", "show", {});
    this.maxDate = new Date(dayjs().format());
    this.minDate = new Date(dayjs().subtract(90, "day").format());
    this.defaultDate = [new Date(dayjs().startOf('day')), new Date(dayjs().endOf('day'))]
    this.getReportType();
    this.getReportList();
  },
  methods: {
    handleCheckImg(imgUrl) {
      this.images = [imgUrl];
      this.imageShow = true;
    },
    handleDealSelect() {
      console.log("handleDealSelect_this.filterForm", this.filterForm);
      this.reportList = [];
      this.pageNum = 1;
      this.finished = false;
      this.loading = true;
      this.getReportList();
    },
    handleDealReset() {
      this.filterForm = {
        reportTimeStart: null,
        reportTimeEnd: null,
        reportType: null, // 上报类型-单选
      };
      this.defaultDate = [new Date(dayjs().startOf('day')), new Date(dayjs().endOf('day'))]
      this.reportList = [];
      this.pageNum = 1;
      this.finished = false;
      this.loading = true;
      this.getReportList();
    },
    onConfirm(date) {
      // console.log("onConfirm__date", date);
      const [start, end] = date;
      this.filterForm.reportTimeStart = start;
      this.filterForm.reportTimeEnd = end;
      this.calenderShow = false;
    },
    transReportTime(reportTime) {
      return dayjs(reportTime).format("YYYY-MM-DD HH:mm:ss");
    },
    onLoad() {
      this.error = false;
      this.pageNum++;
      this.getReportList();
    },
    refresh() {
      this.dataContent = false;
      this.pageNum = 1;
      this.reportList = [];
      this.getReportList();
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.pageNum = 1;
      this.reportList = [];
      this.getReportList();
    },
    handleChangeTab() {
      this.pageNum = 1;
      this.loading = true;
      this.finished = false;
      this.reportList = [];
      this.getReportList();
    },
    getReportType() {
      const { groupId } = this.$route.query;
      reqReportType({ groupId })
        .then((res) => {
          if (res.code === 1) {
            this.reportFilterList = res.data || [];
          }
        })
        .catch((err) => {});
    },
    getReportList() {
      const { groupId } = this.$route.query;
      const { reportTimeStart, reportTimeEnd, reportType } = this.filterForm;
      const startOfday = dayjs(reportTimeStart).startOf('day')
      const endOfday = dayjs(reportTimeEnd).endOf('day')
      const params = {
        groupId,
        reportTimeStart: startOfday.valueOf(), // 00:00:00
        reportTimeEnd: endOfday.valueOf(), // 23:59:59
        reportType,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      handleBuryPoint(
        "h5-sudaseeker_reportListPage",
        "reqReportPageList_params",
        params
      );
      reqReportPageList(params)
        .then((res) => {
          console.log("reqReportPageList-res", res);
          this.loading = false;
          this.dataContent = true;
          const { isMore, items = [] } = res.data || {};
          if (res.code === 1) {
            this.dataContent = true;
            this.reportList = Array.isArray(items)
              ? this.reportList.concat(items)
              : this.reportList;
            this.showEmptyData = this.reportList.length === 0;
            if (!isMore || (Array.isArray(items) && items.length < 10)) {
              this.finished = true;
            }
            console.log("this.reportList", this.reportList);
          } else {
            this.error = true;
            this.pageNum--;
            this.finished = false;
            handleBuryPoint(
              "h5-sudaseeker_reportListPage",
              "reqReportPageList_err",
              {
                code: res?.code,
              }
            );
          }
        })
        .catch((err) => {
          console.log("reqReportPageList-err", err);
          handleBuryPoint(
            "h5-sudaseeker_reportListPage",
            "reqReportPageList_catch",
            {}
          );
          this.error = true;
          this.pageNum--;
          this.finished = false;
        });
    },
  },
};
</script>
<style lang="less">
.reportList_wrapper {
  .filter_area_right {
    .van-button {
      padding: 0 38px;
      height: 60px;
      margin-right: 10px;
    }
  }
}
</style>
<style lang="less" scoped>
.reportList_wrapper {
  padding: 20px 0;
  box-sizing: border-box;
  width: 100%;
  min-height: calc(100vh - 20px);
  background-color: #f7f7f7;
  * {
    box-sizing: border-box;
  }
  .report_filter_wrapper {
    display: flex;
    flex-direction: column;
    padding: 10px 40px;
    .filter_area_left {
      flex: 1;
      display: flex;
      flex-wrap: wrap;
      .report_filter_item {
        display: flex;
      }
      .filter_item_header {
        font-size: 32px;
      }
      .filter_item_value {
        font-size: 32px;
      }
    }
    .filter_area_right {
      align-self: flex-end;
    }
  }
  .mainContent_wrapper {
    margin: 20px 30px;
    display: flex;
    flex-direction: column;
    .singleList_wrapper {
      display: flex;
      flex-direction: row;
      width: 100%;
      margin-bottom: 10px;
      padding: 24px;
      border-radius: 24px;
      background-color: #ffffff;
      border: 2px solid #f7f7f7;
      .name_box {
        width: 200px;
        display: flex;
        justify-content: center;
        text-align: center;
        margin-bottom: 4px;
        .username {
          font-size: 30px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .time_box {
        font-size: 26px;
        color: rgba(0, 0, 0, 0.5);
      }
      .merchant_name {
        font-size: 28px;
        font-weight: bold;
      }
      .desc_box {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        margin: 4px 0;
        .tit {
          width: 130px;
          font-size: 24px;
          padding: 8px 0px;
        }
        .type_tag_box{
          flex: 1;
          display: flex;
          flex-wrap: wrap;
        }
        .type_tag {
          display: flex;
          flex-wrap: wrap;
          color: rgba(0, 0, 0, 0.9);
          font-size: 24px;
          background-color: #f4f6f9;
          padding: 8px 10px;
          margin: 0 6px 4px 0;
          border-radius: 8px;
        }
      }
      .desc_wrap {
        display: flex;
        flex-wrap: wrap;
        .tit {
          font-size: 24px;
          width: 130px;
        }
        .desc {
          flex: 1;
          font-size: 24px;
          overflow-wrap: break-word;
        }
      }

      .merchant_info_box {
        flex: 1;
        display: flex;
        flex-direction: column;
        margin-left: 20px;
      }
      .image_box {
        position: relative;
        width: 200px;
        height: 200px;
        align-self: center;
        img {
          width: 100%;
          height: 100%;
          border-radius: 16px;
        }
      }
    }
  }

  .list_empty_wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    flex: 1;
    z-index: 999;
    // background: cadetblue;
    padding-top: 80px;
    img {
      width: 260px;
      height: 240px;
      margin-bottom: 20px;
    }
    p {
      font-size: 4.27vw;
      color: #333333;
    }
  }

  .error_box {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding-top: 100px;
    span {
      font-size: 38px;
      margin-bottom: 20px;
    }
  }
}
</style>
